module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Dedication#uuhALapISGPeKY9fokEsx2A",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_01#ucWDNyqLxA58lzivc4qzTxA"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_02#ukKrGwYnNlMVUPJYardTWhB"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_03#uix8KfRWCtBSZozHJqX2cqE"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_04#ugqmX9BtRFAel5dnXIHnguB"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_05#uizYw26MNcYeqq2A6bDjUD7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_06#uHM5DE8jFeQzY3gTBR3Foi7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_07#u6tyjTK5QID6BwTK434IOo3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_08#uwbkT9F9kM3ylDXTrHcn9HE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_09#uyxZN64lVLs4bHlkeB9Wbi5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_10#uWRUylgFJBV4GfsY3S622F9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_11#uEXi8zt3UBZRJ64Wf8DG89G",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_12#uc4ZVMQiK8NCdVIzq4DDAQB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_13#uIyQH8FEWfILpRmMyOuNjs7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_14#uh4tvPgi8cehMz9jCTFTMoF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_15#uiNuem8rKJCydCVsvzWNcpF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_16#uQrhAWl3KYETCvk5bgJ8Ki3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_17#ucpbflJfBTMJhXe8LrVkIKB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_18#u2QNBJZK2zfLVAYRqdi5dy7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_19#ufl2yz2JS4DaqLoYp57wn4F",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_20#u95ikYObq2HjddiCTkW3al9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Afterword#up9a87HcZiugXggbHzWcYXB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTERWORD")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97f42f88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 69
// module chunks = 0